"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicSocketFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "error",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "info",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "detail",
                type: "uint256",
            },
        ],
        name: "Failure",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingImplementation",
                type: "address",
            },
        ],
        name: "NewPendingImplementation",
        type: "event",
    },
    {
        payable: true,
        stateMutability: "payable",
        type: "fallback",
    },
    {
        constant: false,
        inputs: [],
        name: "_acceptAdmin",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "_acceptImplementation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newPendingImplementation",
                type: "address",
            },
        ],
        name: "_setPendingImplementation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingTectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class TectonicSocketFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicSocketFactory = TectonicSocketFactory;
TectonicSocketFactory.bytecode = _bytecode;
TectonicSocketFactory.abi = _abi;
//# sourceMappingURL=TectonicSocketFactory.js.map